<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-09-09                                                         -
  ----------------------------------------------------------------------------->

<template>
  <yega1-cards-list header="BTO Models"
                    col-xl="12" col-lg="12" col-md="12" col-sm="12" col-classes="m-0 p-0" card-body-classes="p-0"
                    data-store-name="ConfigurationTemplatesStore"
                    :data-store-query="templateQuery"
                    :data-initial-load="true">
    <template v-slot:filter_actions>
      <span></span>
    </template>
    <template v-slot:card="data">
      <slot name="cardbody" v-bind:item="data.item">
        <b-card>
            <b-card-text>
              <div class="d-flex justify-content-between">
                <h4 class="text-danger">{{ data.item.attribute_store['short-name'] }}</h4>
                <b-button variant="link" :to="{name:'configure_bto_path', params: {template_id:data.item.id}}">{{ data.item.attribute_store['bto_simple_description'] }}</b-button>
                <span><b-badge>{{ formatCurrency(data.item.attribute_store['anchor-price']) }}</b-badge></span>
              </div>
            </b-card-text>
        </b-card>
      </slot>
    </template>
    <template v-slot:sort_source="data">
      <yega1-sorter :sort-func="templateSortFunction"></yega1-sorter>
    </template>
  </yega1-cards-list>
</template>

<script>
import Yega1CardsList from "../yega/yega1/yega1-cards-list.vue";
import Yega1FilterBox from "../yega/yega1/yega1-filter-box.vue";
import Yega1AxiosDataSource from "../yega/yega1/yega1-axios-data-source.vue";
import Yega1Sorter from "../yega/yega1/yega1-sorter.vue";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";
import YesNo from "../../enums/yes-no";
export default {
  name: "bto-templates-list",
  props:{
    templateQuery:{
      type:Object,
      default:function(){
       return {
         attribute_query_hash:{'is_listed':YesNo.YES,'template_is_bto':YesNo.YES},
         namespace_query_hash:{'is-active':YesNo.YES}
       };
      }
    },
    templateSortFunction:{
      type: Function,
      default(a,b){
        let aVal = a.attribute_store['order'];
        let bVal = b.attribute_store['order'];
        return ('' + aVal).localeCompare('' + bVal);
      }
    }
  },
  components: {Yega1Sorter, Yega1AxiosDataSource, Yega1FilterBox, Yega1CardsList},
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  }
}
</script>

<style scoped>

</style>
